import {
  Directive,
  ElementRef,
  AfterViewInit,
  OnDestroy,
  HostBinding,
  NgZone
} from '@angular/core';

@Directive({
  selector: '[appFadeIn]',
  standalone: true
})
export class FadeInDirective implements AfterViewInit, OnDestroy {
  private observer!: IntersectionObserver;

  @HostBinding('class.fade-in') fadeIn = true;
  @HostBinding('class.visible') isVisible = true;

  constructor(private el: ElementRef<HTMLElement>, private ngZone: NgZone) {}

  ngAfterViewInit(): void {
    if (!('IntersectionObserver' in window)) {
      return;
    }

    this.observer = new IntersectionObserver(
      entries => {
        entries.forEach(entry => {
          this.ngZone.run(() => {
            if (entry.isIntersecting) {
              this.isVisible = true;
              this.observer.unobserve(this.el.nativeElement);
            }
          });
        });
      },
      { threshold: 0.01, rootMargin: '0px 0px -10% 0px' }
    );

    this.observer.observe(this.el.nativeElement);
  }

  ngOnDestroy(): void {
    this.observer?.disconnect();
  }
}
